import { AppointmentType, getDefaultAbbreviationFromType, translateAppointmentType } from "@model/models";

export default (type: AppointmentType, abbr = false) => {
    return abbr ? getDefaultAbbreviationFromType(type) : translateAppointmentType(type);
}